import { render, staticRenderFns } from "./Proscreenmenu.vue?vue&type=template&id=d90bb0a0&"
import script from "./Proscreenmenu.vue?vue&type=script&lang=js&"
export * from "./Proscreenmenu.vue?vue&type=script&lang=js&"
import style0 from "./Proscreenmenu.vue?vue&type=style&index=0&id=d90bb0a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports